import { render, staticRenderFns } from "./Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm.vue?vue&type=template&id=4608f31f"
import script from "./Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports